var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-form"},[(_vm.isLinksMode)?_c('search-form-menu'):_c('search-form-tabs',{on:{"onTabChange":_vm.tabChange}}),_c(_vm.serviceSearchForm,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }